"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendBccEmailConfirmation = exports.SendBccEmailConfirmationActionTypes = exports.sendBccEmailConfirmation = exports.ResendBccEmailConfirmation = exports.ResendBccEmailConfirmationActionTypes = exports.resendBccEmailConfirmation = exports.DisableBccEmail = exports.DisableBccEmailActionTypes = exports.disableBccEmail = exports.BccEmailActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var generateDangerNotificationForSendBcc = function generateDangerNotificationForSendBcc(error, message) {
  var jsonError = error.responseJSON;

  if (jsonError && jsonError.errorType === 'FORBIDDEN_MX_GROUP') {
    return (0, _actions.createDangerNotificationMeta)(_I18n.default.text(message + "MxForbidden", {
      domain: jsonError.errorTokens.Domain[0],
      mxGroup: jsonError.errorTokens.MxGroup[0]
    }));
  }

  return (0, _actions.createDangerNotificationMeta)(_I18n.default.text(message));
};

var BccEmailActionTypes = (0, _namespacedKeyMirror.default)({
  DISABLE_BCC_EMAIL: null,
  RESEND_BCC_EMAIL_CONFIRMATION: null,
  SEND_BCC_EMAIL_CONFIRMATION: null
}, _constants.BCC_EMAIL);
exports.BccEmailActionTypes = BccEmailActionTypes;
var disableBccEmail = (0, _fluxActions.createAction)(BccEmailActionTypes.DISABLE_BCC_EMAIL);
exports.disableBccEmail = disableBccEmail;
var DisableBccEmailActionTypes = (0, _actions.createRequestTypes)(BccEmailActionTypes.DISABLE_BCC_EMAIL);
exports.DisableBccEmailActionTypes = DisableBccEmailActionTypes;
var DisableBccEmail = (0, _actions.createRequestActions)(DisableBccEmailActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DisableBccEmailActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.email.notifications.disableBccEmailSuccess')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DisableBccEmailActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.email.notifications.disableBccEmailFailure')));
  }
});
exports.DisableBccEmail = DisableBccEmail;
var resendBccEmailConfirmation = (0, _fluxActions.createAction)(BccEmailActionTypes.RESEND_BCC_EMAIL_CONFIRMATION);
exports.resendBccEmailConfirmation = resendBccEmailConfirmation;
var ResendBccEmailConfirmationActionTypes = (0, _actions.createRequestTypes)(BccEmailActionTypes.RESEND_BCC_EMAIL_CONFIRMATION);
exports.ResendBccEmailConfirmationActionTypes = ResendBccEmailConfirmationActionTypes;
var ResendBccEmailConfirmation = (0, _actions.createRequestActions)(ResendBccEmailConfirmationActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ResendBccEmailConfirmationActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.email.notifications.resendBccEmailSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(error) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ResendBccEmailConfirmationActionTypes.base, _RequestStatusTypes.default.FAILED), generateDangerNotificationForSendBcc(error, 'marketing.email.notifications.resendBccEmailFailure'));
  }
});
exports.ResendBccEmailConfirmation = ResendBccEmailConfirmation;
var sendBccEmailConfirmation = (0, _fluxActions.createAction)(BccEmailActionTypes.SEND_BCC_EMAIL_CONFIRMATION, (0, _actions.mapPayloadTo)('bccEmail'));
exports.sendBccEmailConfirmation = sendBccEmailConfirmation;
var SendBccEmailConfirmationActionTypes = (0, _actions.createRequestTypes)(BccEmailActionTypes.SEND_BCC_EMAIL_CONFIRMATION);
exports.SendBccEmailConfirmationActionTypes = SendBccEmailConfirmationActionTypes;
var SendBccEmailConfirmation = (0, _actions.createRequestActions)(SendBccEmailConfirmationActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SendBccEmailConfirmationActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.email.notifications.sendBccEmailSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(error) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SendBccEmailConfirmationActionTypes.base, _RequestStatusTypes.default.FAILED), generateDangerNotificationForSendBcc(error, 'marketing.email.notifications.sendBccEmailFailure'));
  }
});
exports.SendBccEmailConfirmation = SendBccEmailConfirmation;